import { defaultAxios, IParams } from '../base';

export interface IPutLoanAgreeInfo extends IParams {
  mediaCd: string;
  certYn: string;
  passYn: string;
  bankYn: string;
  credYn: string;
  contYn: string;
}

export const putLoanAgreeInfo = async (params: any) => {
  return await defaultAxios().put(`/loan/agreeInfo`, params);
};
